// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__21QO9","question":"Question_question__2nTb1","description":"Question_description__3txUO"};